import { render, staticRenderFns } from "./CardCompass.vue?vue&type=template&id=f245cb02&scoped=true&"
import script from "./CardCompass.vue?vue&type=script&lang=js&"
export * from "./CardCompass.vue?vue&type=script&lang=js&"
import style0 from "./CardCompass.vue?vue&type=style&index=0&id=f245cb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f245cb02",
  null
  
)

export default component.exports